<div class="p-2 my-auto mx-auto relative">

  <div class="bg-primary_light rounded-full flex absolute right-0 top-0 w-7 h-7 items-center justify-center shadow-md cursor-pointer"
    (click)="cerrar()">
    <ion-icon name="close-outline" class="text-lg text-white"></ion-icon>
  </div>

  <div class="bg-white modal-seleccion-evaluacion rounded-lg">

    <!-- cabecera -->
    <div class="text-base md:text-lg font-semibold text-center flex items-center justify-center bg-primary text-white rounded-t-lg p-3">
      <span>{{ tema?.nombre }}</span>
    </div>

    <!-- ───────── paso 1: elegir evaluación ───────── -->
    <div *ngIf="paso === 'lista'" class="rounded-b-lg px-4 py-4 lg:px-5 flex flex-col gap-3">

      <p class="text-sm lg:text-base font-medium text-gray-800">
        Completa las evaluaciones.
      </p>

      <!-- teórica -->
      <button *ngIf="tieneTeorica" type="button"
        class="w-full text-left rounded-lg border-1 p-3 lg:p-4 flex items-start gap-3 transition-colors duration-150"
        [ngClass]="teoricaBloqueada && !teoricaConResultado ? 'border-gray-250 bg-gray-100 opacity-65 cursor-not-allowed' : 'border-gray-250 bg-white hover:border-primary'"
        [disabled]="teoricaBloqueada && !teoricaConResultado"
        (click)="elegirTeorica()">

        <div class="shrink-0 w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
          <mat-icon class="mdi mdi-clipboard-text-outline text-primary text-2xl"></mat-icon>
        </div>

        <div class="grow-default min-w-0 flex flex-col gap-1">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm lg:text-base font-bold text-gray-1000">{{ teoricaTitulo }}</span>
            <span class="rounded-full px-2 py-05 text-xxs font-semibold"
              [ngClass]="teoricaCompletada
                ? 'bg-green-200 text-teal-800'
                : teoricaBloqueada
                ? 'bg-gray-200 text-gray-800'
                : 'bg-orange-200 text-orange-700'">
              {{ teoricaChip }}
            </span>
          </div>
          <span *ngIf="teoricaConResultado" class="text-xs lg:text-sm font-semibold text-primary">
            {{ tema?.estado_tema === 'realizado' ? 'Toca para ver el estado de tu entrega.' : 'Toca para ver tu nota y los comentarios.' }}
          </span>
          <span *ngIf="teoricaEsScorm" class="text-xs lg:text-sm text-gray-700">
            Se abre dentro del contenido SCORM.
          </span>
          <span class="text-xs lg:text-sm text-gray-700">
            Intentos restantes: {{ tema?.intentos_restantes }}
            <!-- <ng-container *ngIf="modEvaluaciones?.nota_aprobatoria">
              · Nota aprobatoria: {{ modEvaluaciones.nota_aprobatoria }}
            </ng-container> -->
          </span>
        </div>

        <mat-icon class="mdi mdi-chevron-right text-gray-500 text-xl shrink-0 self-center"></mat-icon>
      </button>

      <!-- práctica -->
      <button *ngIf="roleplay" type="button"
        class="w-full text-left rounded-lg border-1 p-3 lg:p-4 flex items-start gap-3 transition-colors duration-150"
        [ngClass]="practicaBloqueada ? 'border-gray-250 bg-gray-100 opacity-65 cursor-not-allowed' : 'border-gray-250 bg-white hover:border-primary'"
        [disabled]="practicaBloqueada"
        (click)="elegirPractica()">

        <div class="shrink-0 w-10 h-10 rounded-lg bg-indigo-100 flex items-center justify-center">
          <mat-icon class="mdi mdi-drama-masks text-primary text-2xl"></mat-icon>
        </div>

        <div class="grow-default min-w-0 flex flex-col gap-1">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm lg:text-base font-bold text-gray-1000">Evaluación roleplay</span>
            <span class="inline-flex items-center gap-1.5 rounded-full bg-gray-200 px-2 py-05 text-xxs font-semibold text-gray-800">
              <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span>
              {{ modalidadLabel }}
            </span>
            <span class="rounded-full px-2 py-05 text-xxs font-semibold"
              [ngClass]="practicaCompletada
                ? 'bg-green-200 text-teal-800'
                : practicaBloqueada
                ? 'bg-gray-200 text-gray-800'
                : 'bg-orange-200 text-orange-700'">
              {{ practicaChip }}
            </span>
          </div>
          <span class="text-xs lg:text-sm text-gray-700 block truncate">{{ roleplay.scenario?.title }}</span>
          <span *ngIf="modalidadNoSoportada" class="text-xs lg:text-sm text-gray-700">
            No disponible en esta versión de la app.
          </span>
          <!-- Aprobada sin repetición: el contador de intentos mentiría, porque
               le pueden quedar y aun así no puede entrar. -->
          <span *ngIf="!modalidadNoSoportada && practicaCerradaPorAprobacion" class="text-xs lg:text-sm text-gray-700">
            Ya aprobaste esta evaluación.
          </span>
          <span *ngIf="!modalidadNoSoportada && !practicaCerradaPorAprobacion" class="text-xs lg:text-sm text-gray-700">
            Intentos restantes: {{ intentosRestantes }}
            <!-- <ng-container *ngIf="roleplay.max_attempts"> de {{ roleplay.max_attempts }}</ng-container> -->
          </span>
        </div>

        <mat-icon class="mdi mdi-chevron-right text-gray-500 text-xl shrink-0 self-center"></mat-icon>
      </button>

    </div>

    <!-- ───────── paso 2: indicaciones de la práctica ───────── -->
    <div *ngIf="paso === 'indicaciones-practica' && roleplay" class="rounded-b-lg px-5 py-4">

      <p class="text-sm lg:text-base font-bold text-gray-1000 mb-2">{{ roleplay.scenario?.title }}</p>

      <ul class="list-disc ml-5 text-sm lg:text-base font-medium">
        <li *ngFor="let indicacion of indicaciones" class="p-1">{{ indicacion }}</li>
        <li *ngIf="indicacionModalidad" class="p-1">{{ indicacionModalidad }}</li>
        <li *ngIf="!practicaEvaluable" class="p-1">
          No lleva nota: es un paso que debes completar para terminar el tema.
        </li>
        <li *ngIf="notaCombinadaLabel" class="p-1">{{ notaCombinadaLabel }}</li>
      </ul>

      <div class="flex justify-center">
        <div class="py-2 text-sm lg:text-base font-medium text-gray-800 flex flex-col text-center">
          <span class="px-1">Intentos restantes: <b>{{ intentosRestantes }}</b></span>
        </div>
      </div>

      <hr class="mt-1 mb-3 bg-gray-250 border-gray-250" />

      <div class="flex items-center justify-center gap-3 mt-3 md:mt-4">
        <button *ngIf="puedeVolver" type="button" (click)="volverALista()"
          class="bg-white border-1 border-gray-350 text-gray-800 rounded-lg font-semibold text-xs py-1.5 px-4 xl:py-2 lg:text-base">
          Volver
        </button>
        <button type="button" (click)="empezarPractica()"
          [eventTracker]='{"identifier":"Tema:Empezar_evaluacion_practica","category":"button_click","action":"Empezar evaluación práctica - modal de confirmación"}'
          class="bg-primary text-white rounded-lg w-24 font-semibold text-xs py-1.5 px-4 xl:py-2 xl:px-3 lg:text-base">
          Empezar
        </button>
      </div>

    </div>

  </div>
</div>
